import { colors } from '@mui/material';
import { designTokens } from './tokens';

export const lightPalette = {
  mode: 'light',
  primary: {
    main: designTokens.customColors.primary.main,
    light: designTokens.customColors.primary.light,
    dark: designTokens.customColors.primary.dark,
    contrastText: designTokens.customColors.primary.contrastText,
  },
  secondary: {
    main: designTokens.customColors.secondary.main,
    light: designTokens.customColors.secondary.light,
    dark: designTokens.customColors.secondary.dark,
    contrastText: designTokens.customColors.secondary.contrastText,
  },
  text: {
    primary: colors.blueGrey[900],
    secondary: colors.blueGrey[600],
    disabled: colors.blueGrey[400],
  },
  background: {
    default: colors.common.white,
    paper: colors.common.white,
    dark: '#f6f8fb',
    light: '#fafafa',
    grey: '#cccccc',
  },
  action: {
    active: colors.blueGrey[600],
    hover: designTokens.customColors.action.hover,
    selected: designTokens.customColors.action.selected,
    disabled: designTokens.customColors.action.disabled,
  },
  success: {
    main: '#4caf50',
    light: '#81c784',
    dark: '#2e7d32',
  },
  warning: {
    main: '#ff9800',
    light: '#ffb74d',
    dark: '#f57c00',
  },
  error: {
    main: '#f44336',
    light: '#e57373',
    dark: '#d32f2f',
  },
  info: {
    main: '#2196f3',
    light: '#64b5f6',
    dark: '#1976d2',
  },
  divider: colors.grey[200],

  // Custom theme colors
  button: {
    main: '#0d151c',
    clickable: 'rgba(211, 211, 211, 0.25)',
    hover: designTokens.customColors.action.hover,
  },
  tab: {
    default: colors.blueGrey[600],
    active: designTokens.customColors.primary.main,
    inactive: '#efeeea',
    inactiveBackground: '#e0e0e0',
    hover: '#edeef1',
    indicator: designTokens.customColors.primary.main,
  },
  header: {
    dark: '#0d151c',
  },
  cancel: colors.red[800],
  icons: 'MediumPurple',
  row: {
    selected: designTokens.customColors.action.selected,
    selectedHover: '#dcdcdc',
  },
  switch: {
    on: designTokens.harvestColors.green,
    off: '#EAE9E7',
  },
  harvestColors: designTokens.harvestColors,
};

export const darkPalette = {
  mode: 'dark',
  primary: {
    main: designTokens.customColors.primary.main,
    light: designTokens.customColors.primary.light,
    dark: designTokens.customColors.primary.dark,
    contrastText: designTokens.customColors.primary.contrastText,
  },
  secondary: {
    main: designTokens.customColors.primary.main,
    light: designTokens.customColors.primary.light,
    dark: designTokens.customColors.primary.dark,
  },
  text: {
    primary: '#efeeea',
    secondary: '#87a7c7',
    disabled: 'rgba(255, 255, 255, 0.5)',
  },
  background: {
    default: '#1f3042',
    paper: '#1f3042',
    dark: '#131e29',
    grey: '#cccccc',
  },
  action: {
    active: 'rgba(255, 255, 255, 0.54)',
    hover: 'rgba(255, 255, 255, 0.04)',
    selected: 'rgba(255, 255, 255, 0.08)',
    disabled: 'rgba(255, 255, 255, 0.26)',
    disabledBackground: 'rgba(255, 255, 255, 0.12)',
    focus: 'rgba(255, 255, 255, 0.12)',
  },
  success: {
    main: '#4caf50',
    light: '#81c784',
    dark: '#2e7d32',
  },
  warning: {
    main: '#ff9800',
    light: '#ffb74d',
    dark: '#f57c00',
  },
  error: {
    main: '#f44336',
    light: '#e57373',
    dark: '#d32f2f',
  },
  info: {
    main: '#2196f3',
    light: '#64b5f6',
    dark: '#1976d2',
  },
  divider: 'rgba(255, 255, 255, 0.12)',

  // Custom theme colors
  button: {
    main: designTokens.customColors.primary.main,
    clickable: 'rgba(211, 211, 211, 0.25)',
    hover: 'rgba(173, 216, 230, 0.5)',
  },
  tab: {
    default: '#87a7c1',
    active: designTokens.customColors.primary.main,
    inactiveBackground: 'rgba(255, 255, 255, 0.04)',
    inactiveText: '#efeeea',
    hover: 'rgba(255, 255, 255, 0.12)',
    indicator: designTokens.customColors.primary.main,
  },
  cancel: colors.red[800],
  icons: 'MediumPurple',
  row: {
    selected: '#383c3c',
    selectedHover: '#403c3c',
  },
  switch: {
    on: designTokens.harvestColors.green,
    off: '#EAE9E7',
  },
  harvestColors: designTokens.harvestColors,
};
